<div class="business-navbar__sidebar"
    [class.business-navbar__sidebar--open]="isOpen$ | async" #sidebar>
    <div class="business-navbar__sidebar__header">
        <ng-content select="[nav-header]"></ng-content>
    </div>
    <div class="business-navbar__sidebar__content">
        <ng-content select="[nav-items]"></ng-content>
    </div>
    <div class="business-navbar__sidebar__footer">
        <ng-content select="[nav-footer]"></ng-content>
    </div>
</div>
<div class="business-navbar__sidebar__overlay"
    [ngClass]="{'business-navbar__sidebar__overlay--visible': (showOverlay$ | async)}" (click)="closeMenu()"></div>
